/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MarketRSSWatchSettingReport', 'model/MarketRSSWatchSetting'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MarketRSSWatchSettingReport'), require('../model/MarketRSSWatchSetting'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MarketRSSWatchSettingReportApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MarketRSSWatchSettingReport, root.ForStractionServiceApi.MarketRSSWatchSetting);
  }
}(this, function(ApiClient, MarketRSSWatchSettingReport, MarketRSSWatchSetting) {
  'use strict';

  /**
   * MarketRSSWatchSettingReport service.
   * @module api/MarketRSSWatchSettingReportApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new MarketRSSWatchSettingReportApi. 
   * @alias module:api/MarketRSSWatchSettingReportApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPut operation.
     * @callback module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketRSSWatchSettingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addSettingSaveFeedAndLoadReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/MarketRSSWatchSetting} body 
     * @param {module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketRSSWatchSettingReport}
     */
    this.marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling marketRSSWatchSettingReportAddSettingSaveFeedAndLoadReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MarketRSSWatchSettingReport;

      return this.apiClient.callApi(
        '/MarketRSSWatchSettingReport/addSettingSaveFeedAndLoadReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketRSSWatchSettingReportLoadAllGet operation.
     * @callback module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MarketRSSWatchSettingReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MarketRSSWatchSettingReport>}
     */
    this.marketRSSWatchSettingReportLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketRSSWatchSettingReportLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [MarketRSSWatchSettingReport];

      return this.apiClient.callApi(
        '/MarketRSSWatchSettingReport/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketRSSWatchSettingReportLoadGet operation.
     * @callback module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketRSSWatchSettingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketRSSWatchSettingReport}
     */
    this.marketRSSWatchSettingReportLoadGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketRSSWatchSettingReportLoadGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling marketRSSWatchSettingReportLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MarketRSSWatchSettingReport;

      return this.apiClient.callApi(
        '/MarketRSSWatchSettingReport/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGet operation.
     * @callback module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketRSSWatchSettingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * updateFeedDataWithLatestEntriesAndLoadReport
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/MarketRSSWatchSettingReportApi~marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketRSSWatchSettingReport}
     */
    this.marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling marketRSSWatchSettingReportUpdateFeedDataWithLatestEntriesAndLoadReportGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MarketRSSWatchSettingReport;

      return this.apiClient.callApi(
        '/MarketRSSWatchSettingReport/updateFeedDataWithLatestEntriesAndLoadReport', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
